import axios from "axios";
import { useEffect, useState } from "react";
import { FaInfoCircle, FaSyncAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchData } from "../../../../../store/slice/Organizer";
import Alert from "../../../../global/alert/Alert";

const AddPointsOfSale = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const api = process.env.REACT_APP_SERVER_API;
  const { user } = useSelector((state) => state.authUser);
  const { sales } = useSelector((state) => state.organizer);
  const disaptch = useDispatch();

  const [isPanding, setPanding] = useState(false);
  const [errors, setErrors] = useState({});
  const [newPointsOfSale, setNewPointsOfSale] = useState({
    name: "",
    user_name: "",
    password: "",
    password_confirmation: "",
  });

  // validate fields
  const validateFields = () => {
    let newErrors = {};

    if (!newPointsOfSale.name.trim()) newErrors.name = "Please Enter Name";
    if (!newPointsOfSale.user_name.trim())
      newErrors.user_name = "Please Enter Username";

    if (!newPointsOfSale.password && !id)
      newErrors.password = "Please Enter Password";
    if (!id && newPointsOfSale.password && newPointsOfSale.password.length < 6)
      newErrors.password = "The password must be at least 6 characters";
    if (
      newPointsOfSale.password !== newPointsOfSale.password_confirmation &&
      !id
    )
      newErrors.password_confirmation = "Passwords do not match";

    if (id && newPointsOfSale.password && newPointsOfSale.password.length < 6)
      newErrors.password = "The password must be at least 6 characters";
    if (
      (newPointsOfSale.password || newPointsOfSale.password_confirmation) &&
      newPointsOfSale.password !== newPointsOfSale.password_confirmation &&
      id
    )
      newErrors.password_confirmation = "Passwords do not match";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };
  //
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewPointsOfSale({ ...newPointsOfSale, [name]: value });
  };
  // for adding a new point of sale to the  database
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) return;

    try {
      setPanding(true);
      if (!id) {
        const { data } = await axios.post(
          `${api}/organizer/add_sale`,
          newPointsOfSale,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        if (data.status === 201) {
          toast.success(data.message);
          setPanding(false);
          setNewPointsOfSale({
            name: "",
            user_name: "",
            password: "",
            password_confirmation: "",
          });
        }
      } else {
        const { data } = await axios.post(
          `${api}/organizer/update_sale`,
          {
            id: newPointsOfSale.id,
            name: newPointsOfSale.name,
            user_name: newPointsOfSale.user_name,
            password: newPointsOfSale.password,
            password_confirmation: newPointsOfSale.password_confirmation,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        if (data.status === 200) {
          toast.success(data.message);
          setPanding(false);
        }
      }
      navigate("/en/dashboard/organizer/my-points-of-sale");
      disaptch(
        fetchData({
          getData: "organizer/sales",
          token: user.token,
          state: "sales",
        })
      );
    } catch (error) {
      toast.error(error.response.data.message);
      setPanding(false);
    }
  };

  // for get single data for edit
  useEffect(() => {
    id && setNewPointsOfSale(sales.find((ele) => ele.id == id));
  }, [id]);

  // this is alert maessage
  const msg = {
    icon: <FaInfoCircle className="me-3" />,
    type: "alert-info",
    text: "Leave the password empty to keep the old one",
  };

  return (
    <>
      <div className="card setting">
        <div className="card-body">
          {id && <Alert {...msg} />}
          <form action="" className="signform" onSubmit={handleSubmit}>
            <div className="mb-4">
              <div className="mb-1">
                <label htmlFor="name" className="form-label fw-600">
                  Name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  className={`form-control ${errors.name && "is-invalid"}`}
                  value={newPointsOfSale.name}
                  onChange={handleChange}
                />
              </div>
              {errors.name && (
                <small className="text-danger d-block">{errors.name}</small>
              )}
            </div>
            <div className="mb-4">
              <div className="mb-1">
                <label htmlFor="user_name" className="form-label fw-600">
                  Username<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  name="user_name"
                  id="user_name"
                  className={`form-control ${errors.user_name && "is-invalid"}`}
                  value={newPointsOfSale.user_name}
                  onChange={handleChange}
                />
              </div>
              {errors.user_name && (
                <small className="text-danger d-block">
                  {errors.user_name}
                </small>
              )}
            </div>
            <div className="mb-4">
              <div className="mb-1">
                <label htmlFor="password" className="form-label fw-600">
                  Password<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  className={`form-control ${errors.password && "is-invalid"}`}
                  value={newPointsOfSale.password}
                  onChange={handleChange}
                />
              </div>
              {errors.password && (
                <small className="text-danger d-block">{errors.password}</small>
              )}
            </div>
            <div className="mb-4">
              <div className="mb-1">
                <label
                  htmlFor="password_confirmation"
                  className="form-label fw-600"
                >
                  Repeat password<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="password"
                  name="password_confirmation"
                  id="password_confirmation"
                  className={`form-control ${
                    errors.password_confirmation && "is-invalid"
                  }`}
                  value={newPointsOfSale.password_confirmation}
                  onChange={handleChange}
                />
              </div>
              {errors.password_confirmation && (
                <small className="text-danger d-block">
                  {errors.password_confirmation}
                </small>
              )}
            </div>

            <div className="form-group mt-3 mb-3">
              <button
                className="btn btn-dark rounded-5"
                disabled={isPanding ? "disabled" : ""}
                type="submit"
              >
                {isPanding ? <FaSyncAlt className="spinIcon" /> : "save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddPointsOfSale;
